import {  Card, CardActions, CardContent, Chip, Divider, ListItem, ListItemButton, Stack, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import React, { forwardRef, useMemo, useState } from "react";
import Box from '@mui/material/Box';
import AndroidIcon from '@mui/icons-material/Android';
import PhonelinkSetupOutlinedIcon from '@mui/icons-material/PhonelinkSetupOutlined';
import styles from "./DeviceItem.module.css";


import {Apps, SettingsOutlined, TextSnippetOutlined, SyncAltOutlined, Lock, NumbersOutlined, HideSource, RemoveCircle, RemoveCircleOutline, Info, Done} from '@mui/icons-material/'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightArrowLeft, faLink } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "components/buttons";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { ConfirmationDialog } from "components/dialogs";
import { useSelector } from "react-redux";
import { isoToDate, isoToDateString, isoToDateTimeString } from "utils/date";

const DeviceItem = forwardRef(({item, onSelect, onEdit}, ref) => { 

    const {id, model, connectedAt, license, lastConnectedAt, isBlock, licenseEndAt, factoryNum} = item;    
    const [openBlockDialog, setOpenBlockDialog] = useState(false);
    const { selectedDevice, activeDetails } = useSelector(state => state.device);

    const blockHandler = (e) => {
        onEdit({id, body: {isBlock: !isBlock}});
        setOpenBlockDialog(false);
    };
    
    const cancelBlockHandler = (e) => {
        setOpenBlockDialog(false);
    };

    const detailsValue = useMemo( () => {
        return id===selectedDevice?.id ? activeDetails.value : '';
    }, [id, activeDetails, selectedDevice]);

    const onItemSelect = (e) => { 
        if(activeDetails) { 
            onSelect(item, {value: activeDetails.value, text: activeDetails.text});
        }
        else onSelect(item, {value: 'info', text: 'Информация'});
    }

    const onButtonClick = (event, value) => {
        event.stopPropagation();
        onSelect(item, {value, text: event.target.textContent});
    };

    const licenseText = useMemo(() => {
        if(!license) return 'Действующей лицензии нет';
        return `${license} до ${isoToDateString(licenseEndAt)}`;
    }, [license]);

    const connectionText = useMemo(() => {
        if(!connectedAt) return 'Связи с устройством не было';
        return isoToDateString(connectedAt);
    }, [connectedAt]);

    const lastConnectionText = useMemo(() => {
        if(!lastConnectedAt) return "Связи с кассой не было";
        return isoToDateTimeString(lastConnectedAt);
    }, [lastConnectedAt]);

    return (
        <ListItemButton
            ref={ref}
            className={"pagelist-item " + (isBlock ? 'disabled' : '')}
            sx={{
                pr:1, pb: 1, pl:0, pt: 0, flexGrow: 1,               
                '& :hover.MuiPaper-root':{
                    backgroundColor: 'rgb(248, 248, 238) !important'
                },
                '&.Mui-selected .MuiCard-root': {
                    backgroundImage: 'unset',
                    backgroundColor: 'aliceblue'
                }
            }}
            disableRipple
            disableTouchRipple
            selected={id===selectedDevice?.id}
            onClick={onItemSelect}
        >   
            <Card sx={{width:'100%'}}> 
                <CardContent sx={{cursor: 'pointer', padding: '4px 8px'}}>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: "hidden"}}> 
                        <Box className={styles.itemIcon}>
                            <PhonelinkSetupOutlinedIcon color='secondary' sx={{ fontSize: 28 }}/>
                        </Box>
                        <Box sx={{display: 'flex', flexDirection: 'column', flexGrow: 1, mr: 1, overflow: "hidden"}}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography sx={{fontSize: 20, textOverflow: "ellipsis", overflow: "hidden"}}>{model}</Typography>
                                <Tooltip title="Заводской номер">
                                    <Chip className={`${styles.selectable} ${styles.factoryNum}`} icon={<NumbersOutlined color='secondary' fontSize="small"/>} label={`ЗН ${factoryNum}`} />
                                </Tooltip>
                            </Stack>
                            <Stack direction="row" spacing={1} my={0.5}>
                                <Tooltip title="Подключена к кабинету">
                                    <Chip icon={<FontAwesomeIcon icon={faLink} />} label={connectionText} />
                                </Tooltip>
                                <Tooltip title="Последний обмен данными">
                                    <Chip icon={<FontAwesomeIcon icon={faArrowRightArrowLeft} />} label={lastConnectionText} />
                                </Tooltip>
                                <Tooltip title="Действующая лицензия">
                                    <Chip icon={<Lock fontSize="small" />} className={styles.key} label={licenseText}/>
                                </Tooltip>
                            </Stack>
                            
                        </Box>
                        <IconButton
                            handler={(e) => {
                                setOpenBlockDialog(true)
                            }}
                            text={isBlock ? 'Разблокировать кассу' : 'Заблокировать кассу'}  
                            iconCmp={isBlock ? <Done className='delete-button'/> : <HideSource className='delete-button'/>}
                        />
                        <ConfirmationDialog
                            title={isBlock ? 'Разблокировать' : 'Заблокировать'}
                            text={<span>{isBlock ? 'Разблокировать' : 'Заблокировать'} кассу <b>{id}</b>?</span>}
                            open={openBlockDialog}
                            onOk={blockHandler}
                            onCancel={cancelBlockHandler}
                        />
                    </Box>                                                  
                </CardContent>
                <Divider variant="middle"/>
                <CardActions className={styles.itemContainer}>
                    <ToggleButtonGroup 
                        size="small"
                        //value={activeDetails.value}
                        value={detailsValue}
                        onChange={onButtonClick}
                        exclusive
                    >
                        <ToggleButton value="apps" className={styles.itemAction}>
                            <Apps />
                            Приложения
                        </ToggleButton>
                        <ToggleButton value="lics" className={styles.itemAction}>
                            <TextSnippetOutlined sx={{marginRight: '4px'}}/>
                            Лицензии
                        </ToggleButton>
                        <ToggleButton value="log" className={styles.itemAction}>
                            <SyncAltOutlined sx={{marginRight: '4px'}}/>
                            Лог
                        </ToggleButton>
                        <ToggleButton value="prefs" className={styles.itemAction}>
                            <SettingsOutlined sx={{marginRight: '4px'}}/>
                            Настройки
                        </ToggleButton>
                        <ToggleButton value="info" className={styles.itemAction}>
                            <Info sx={{marginRight: '4px'}}/>
                            Информация
                        </ToggleButton>
                    </ToggleButtonGroup>
                        
                </CardActions>
            </Card>
        </ListItemButton>
    );
});

export default DeviceItem;